<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import Reserve from '@/dc-it/models/Reserve'

export default {
  name: 'ReservesView',
  components: { TableComponent },
  data() {
    return {
      model: Reserve,
    }
  },
}
</script>

<style scoped>

</style>
